import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputTypes, FormField } from 'taboola-ultimate-ui';
import { withIndication } from 'modules/errors/components/withIndication';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage, FormattedNumber } from 'modules/taboola-common-frontend-modules/i18n';
import { validationFunctions, withInputValidations } from 'modules/taboola-common-frontend-modules/validations';
import { useEventValueHandler } from '../../../../../../hooks';
import CurrencyIcon from '../CurrencyIcon/CurrencyIcon';
import CpaGoalTooltip from './CpaGoalTooltip';
import { useCpaGoalFormFieldValue } from './useCpaGoalFormFieldValue';
import styles from '../commonEditor.module.scss';
import commonStyles from '../commonEditor.module.scss';

const inputPadding = parseInt(commonStyles.currencyInputLeftPadding);

const InputWithValidations = withInputValidations(withIndication(Input), [
    {
        validationFn: validationFunctions.isFloatOrEmpty,
        options: { min: 0 },
        messageId: 'validations.error.campaign.cpaGoal.minValue',
        defaultMessage: 'CPA goal must be a positive number',
    },
]);

const CpaGoal = ({ currency }) => {
    const { value: cpaGoal, onChange, isPermitted } = useCpaGoalFormFieldValue();
    const changeHandler = useEventValueHandler(onChange);

    if (!isPermitted) {
        return null;
    }

    return (
        <FormField
            inputId="cpa-goal"
            label={<FormattedMessage id="campaign.editor.cpa.goal" defaultMessage="CPA Goal (optional)" />}
            description={
                <FormattedMessage
                    id="campaign.editor.cpa.goal.description"
                    defaultMessage="We recommend setting a Cost-Per-Action (CPA) goal. This will help you measure how your campaign is performing against your goal."
                />
            }
            helpText={<CpaGoalTooltip />}
            containerClass={styles['input']}
        >
            <FormattedNumber value={0} minimumIntegerDigits={2}>
                {placeholder => (
                    <InputWithValidations
                        id="cpaGoal"
                        onChange={changeHandler}
                        icon={<CurrencyIcon currency={currency} />}
                        inputPadding={inputPadding}
                        placeholder={placeholder}
                        value={cpaGoal ?? ''}
                        type={InputTypes.NUMBER}
                        data-metrics-event-name={GTM_EVENTS.USABILITY}
                        data-metrics-component="CpaGoal"
                    />
                )}
            </FormattedNumber>
        </FormField>
    );
};

CpaGoal.propTypes = {
    currency: PropTypes.string,
};

export default CpaGoal;
